import { type TypedDocumentNode, gql } from '@apollo/client';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Dialog } from '@sorare/core/src/components/dialog';

import type { EditFirstLineupPlayer_player } from './__generated__/index.graphql';

type Props = {
  open?: boolean;
  onClose?: () => void;
  player: EditFirstLineupPlayer_player | null;
  onSelect?: (player: EditFirstLineupPlayer_player | null) => void;
};
export const EditFirstLineupPlayer = ({
  open,
  onClose,
  player,
  onSelect,
}: Props) => {
  const selectedPlayer = null;

  return (
    <Dialog open={open} onClose={onClose}>
      <Vertical>
        CurrentlySelected: {player?.slug}
        <Button
          onClick={() => onSelect?.(selectedPlayer)}
          color="primary"
          size="medium"
        >
          Select
        </Button>
      </Vertical>
    </Dialog>
  );
};

EditFirstLineupPlayer.fragments = {
  player: gql`
    fragment EditFirstLineupPlayer_player on Player {
      slug
      id
    }
  ` as TypedDocumentNode<EditFirstLineupPlayer_player>,
};
